import { render, staticRenderFns } from "./ApparentPower.vue?vue&type=template&id=0bb24e71&scoped=true&"
import script from "./ApparentPower.vue?vue&type=script&lang=js&"
export * from "./ApparentPower.vue?vue&type=script&lang=js&"
import style0 from "./ApparentPower.vue?vue&type=style&index=0&id=0bb24e71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb24e71",
  null
  
)

export default component.exports